import React, { lazy, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route, } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import WS from 'store/common/ws';
import RecaptchaProvider from 'components/ReCaptchaProvider/ReCaptchaProvider';
import Loader from 'assets/lottie/Loader/Loader';
import 'i18n';
// import SentryInit, { reactErrorhandlers } from 'sentry';
import './index.scss';
import { VERSION } from 'const';
const Root = lazy(() => import('containers/pages'));
const Login = lazy(() => import('containers/pages/Login'));
const TopProjects = lazy(() => import('containers/pages/TopProjects'));
const Trends = lazy(() => import('containers/pages/Trends'));
const Project = lazy(() => import('containers/pages/Project/Project'));
const TopViewers = lazy(() => import('containers/pages/TopViewers'));
const ContactViews = lazy(() => import('containers/pages/ContactViews'));
const Competitors = lazy(() => import('containers/pages/Competitors'));
// if (NODE_ENV === 'production' && globalThis.location.hostname === 'geniemap.net') SentryInit();
dayjs.extend(utc);
new WS();
console.log(VERSION);
/* if ('serviceWorker' in navigator && globalThis.location.hostname !== 'geniemap.net') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((reg) => console.log('SW registered:', reg)) // eslint-disable-line
      .catch((err) => console.error('SW registration failed:', err)); // eslint-disable-line
  });
} */
createRoot(document.getElementById('root')).render(React.createElement(React.Fragment, null,
    React.createElement(BrowserRouter, null,
        React.createElement(Suspense, { fallback: React.createElement(Loader, null) },
            React.createElement(Routes, null,
                React.createElement(Route, { path: "/login", element: React.createElement(RecaptchaProvider, { external: true },
                        React.createElement(Login, null)) }),
                React.createElement(Route, { path: "/*", element: React.createElement(Root, null) },
                    React.createElement(Route, { path: "top-project", element: React.createElement(TopProjects, null) }),
                    React.createElement(Route, { path: "trends", element: React.createElement(Trends, null) }),
                    React.createElement(Route, { path: "projects/:projectId", element: React.createElement(Project, null) }),
                    React.createElement(Route, { path: "projects/:projectId/:adPaymentStatus", element: React.createElement(Project, null) }),
                    React.createElement(Route, { path: "projects/:projectId/top-viewers", element: React.createElement(TopViewers, null) }),
                    React.createElement(Route, { path: "projects/:projectId/contact-views", element: React.createElement(ContactViews, null) }),
                    React.createElement(Route, { path: "projects/:projectId/competitors", element: React.createElement(Competitors, null) }),
                    React.createElement(Route, { path: "*", element: React.createElement(TopProjects, null) }))))),
    React.createElement(ToastContainer, { position: "bottom-left", autoClose: 10000, hideProgressBar: false, limit: 3, pauseOnFocusLoss: true, pauseOnHover: true })));
